import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-19e9698b")

_pushScopeId("data-v-19e9698b")
const _hoisted_1 = { class: "form__input" }
const _hoisted_2 = { class: "input__purpose-other" }
const _hoisted_3 = {
  for: "purpose",
  class: "-medium"
}
const _hoisted_4 = { class: "-required" }
const _hoisted_5 = { class: "input__files" }
const _hoisted_6 = {
  for: "purpose",
  class: "-medium"
}
const _hoisted_7 = { class: "request-form__footer--actions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Alert = _resolveComponent("Alert")
  const _component_CustomConfirmDialog = _resolveComponent("CustomConfirmDialog")
  const _component_RequestConfirm = _resolveComponent("RequestConfirm")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_FileList = _resolveComponent("FileList")
  const _component_FileUploader = _resolveComponent("FileUploader")
  const _component_FileViewer = _resolveComponent("FileViewer")
  const _component_Sidebar = _resolveComponent("Sidebar")
  const _component_Button = _resolveComponent("Button")
  const _component_PageFrame = _resolveComponent("PageFrame")
  const _component_Form = _resolveComponent("Form")

  return (!_ctx.state.isLoading)
    ? (_openBlock(), _createBlock(_component_Form, {
        key: 0,
        class: "online-care__request__form",
        action: "",
        method: "",
        onSubmit: _ctx.saveConfirmDialog
      }, {
        default: _withId(() => [
          (!!_ctx.alert.content)
            ? (_openBlock(), _createBlock(_component_Alert, {
                key: 0,
                alert: _ctx.alert,
                "onUpdate:clear": _cache[1] || (_cache[1] = ($event: any) => (_ctx.alert.content = ''))
              }, null, 8, ["alert"]))
            : _createCommentVNode("", true),
          (_ctx.state.isContent)
            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_CustomConfirmDialog, { group: "save" }),
                _createVNode(_component_RequestConfirm, {
                  ref: "confirm$",
                  accept: _ctx.goBack
                }, null, 8, ["accept"])
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_PageFrame, { class: "form__content" }, _createSlots({
            title: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t('request quick reservation')), 1)
            ]),
            subtitle: _withId(() => [
              _createVNode("span", null, _toDisplayString(_ctx.t('quick reservation description')), 1)
            ]),
            _: 2
          }, [
            (_ctx.state.isContent)
              ? {
                  name: "content",
                  fn: _withId(() => [
                    _createVNode("div", _hoisted_1, [
                      _createVNode("div", _hoisted_2, [
                        _createVNode("label", _hoisted_3, [
                          _createTextVNode(_toDisplayString(_ctx.t('input chief complaint')), 1),
                          _createVNode("span", _hoisted_4, " (" + _toDisplayString(_ctx.t('required')) + ")", 1)
                        ]),
                        _createVNode(_component_Textarea, {
                          modelValue: _ctx.state.purpose.other,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.purpose.other = $event)),
                          rows: 7,
                          cols: 36,
                          id: "purpose"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_5, [
                      _createVNode("label", _hoisted_6, _toDisplayString(_ctx.t('attach files')), 1),
                      (_ctx.state.purpose.files && _ctx.state.purpose.files.length > 0)
                        ? (_openBlock(), _createBlock(_component_FileList, {
                            key: 0,
                            class: "upload-files",
                            list: _ctx.state.purpose.files,
                            onOnSelectedRow: _ctx.onSelectedRow,
                            onDeletedFile: _ctx.deletedFile,
                            id: _ctx.state.id,
                            requestKind: _ctx.RequestKindTypes.OnlineCare
                          }, null, 8, ["list", "onOnSelectedRow", "onDeletedFile", "id", "requestKind"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_FileUploader, {
                        ref: "fileUploader$",
                        isEditable: _ctx.isEditable,
                        onProgress: _ctx.filesProgress,
                        isAllowVideo: true,
                        url: _ctx.url,
                        class: "file-uploader"
                      }, null, 8, ["isEditable", "onProgress", "url"]),
                      _createVNode(_component_Sidebar, {
                        visible: _ctx.state.visibleFull,
                        "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.visibleFull = $event)),
                        baseZIndex: 1000,
                        position: "full",
                        style: {"padding":"20px"}
                      }, {
                        default: _withId(() => [
                          (_ctx.state.selectFile)
                            ? (_openBlock(), _createBlock(_component_FileViewer, {
                                key: 0,
                                select: _ctx.state.selectFile,
                                isSidebar: false
                              }, null, 8, ["select"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["visible"])
                    ])
                  ])
                }
              : undefined,
            (_ctx.state.isContent)
              ? {
                  name: "action",
                  fn: _withId(() => [
                    _createVNode("div", _hoisted_7, [
                      _createVNode(_component_Button, {
                        class: "-button -medium -royalBlue",
                        type: "submit",
                        disabled: _ctx.isValidate ? false : true
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('submit application')), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ])
                }
              : undefined
          ]), 1024)
        ]),
        _: 1
      }, 8, ["onSubmit"]))
    : _createCommentVNode("", true)
})